import React, { Component, useState, useEffect } from "react";
import sectiondata from "../../data/sections.json";
import { Link } from "react-router-dom";
import { searchProperty } from "../../request/apiRquest";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Spin } from "antd";
import FormatePrice from "../../utils/FormatePrice";
import PropertyCallingButton from "../../utils/PropertyCardCall";
import PropertyWhatsAppButton from "../../utils/PropertyCardWhatsApp";
import { Button, Modal } from "antd";
import GetInTouch from "../../utils/getInTouch";
import PropertyDetailsList from "../../JsonData/property-details.json"
import Properties from "../../JsonData/blog-properties.json"


const BlogPropertices = () => {

    const carouselSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false
    };

    const [propertices, setPropertices] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectCities, setSelectedStates] = useState('24');
    const [selectBuildingType, setSelectedBuildingType] = useState('4');
    const [propertyFor, setPropertyFor] = useState('1');
    const [open, setOpen] = useState(false);
    const showModal = () => setOpen(true);
    const handleCancel = () => setOpen(false);

    let propertydata = Properties.Properties;
    const getpropertylist = async () => {
        setLoading(true);
        try {

            setPropertices(propertydata);
        } catch (error) {
            console.error("Error properties is not show ", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getpropertylist();
    }, [])

    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";
    let data = sectiondata.featuredproperties;
    // let Customclass = this.props.Customclass
    //   ? this.props.Customclass
    //   : "pd-top-60";

    // console.log(propertydata, "datatatat");

    //  console.log(propertices, "filter datdtad");

    return (
        <div className={"featured-area  pd-top-40"}>
            <div className="container">
                <div className="section-title text-center">
                    <h2 className="title">Apartment for sale Dubai</h2>
                    <Link className="btn-view-all" to="/properties">View All</Link>
                </div>


                {loading ? (
                    //<div className="text-center">Loading properties...</div>
                    <div className="text-center py-5">
                        <Spin className="custom-orange-spin" size="large" tip="Loading properties..." />
                    </div>
                ) : (
                    <>
                        <div className="row" style={{
                            display: "flex",
                            flexWrap: "nowrap",            // prevent wrapping
                            overflowX: "auto",             // enable horizontal scroll
                            gap: "20px",                   // spacing between cards
                            padding: "10px",
                        }}>
                            {propertices?.length > 0 ? (
                                propertices?.slice(0, 5).map((item, index) => {
                                    const images = item?.image || [];

                                    return (
                                        <div key={index} className="col-xl-4 col-sm-6">
                                            <div className="single-feature">

                                                <div className="thumb position-relative">
                                                    <Button
                                                        className="position-absolute"
                                                        style={{
                                                            top: '10px',
                                                            right: '10px',
                                                            zIndex: 2,
                                                            padding: '6px 12px',
                                                            fontSize: '14px',
                                                            borderRadius: '5px',
                                                            width: "150px",
                                                            color: "#FDA94F"
                                                        }}
                                                        onClick={showModal}
                                                    >
                                                        Enquire Now
                                                    </Button>
                                                    <img
                                                        src={images[0]?.src}
                                                        alt="Property"
                                                        className="img-fluid property-image"
                                                        style={{
                                                            height: '250px',
                                                            width: '100%',
                                                            objectFit: 'cover',
                                                            imageRendering: 'auto',
                                                            display: 'block',
                                                            backfaceVisibility: 'hidden',
                                                            transform: 'translateZ(0)',
                                                            WebkitBackfaceVisibility: 'hidden'
                                                        }}
                                                    />
                                                </div>

                                                <div className="details">
                                                    {/* {data.items.map((item, i) =>
                                                <a href="#" className="feature-logo">
                                                    <img src={publicUrl + item.icon} alt={imagealt} />
                                                </a>
                                            )} */}
                                                    {/* <p className="author" style={{ gap: "15px" }}><i className="fa fa-user" />{item.name || 'Unknown'}</p> */}
                                                    {/* <h6 className="price">
                            {FormatePrice(item.price)} AED
                          </h6> */}
                                                    <h6 className="title readeal-top"><Link >{item.PropertyName}</Link></h6>
                                                    <h6 className="title readeal-top" style={{ fontSize: "12px" }}> <i class="fa fa-home" style={{ color: "orange", fontSize: "15px" }}></i>  {item.Type}</h6>
                                                    <p className="location"><i className="fa fa-map-marker" style={{ marginRight: '5px', color: 'red', color: "orange " }} />
                                                        {item.Area}</p>

                                                    {/* <ul className="info-list">
                            <li key={index}><i className="fa fa-bed" /> {item.bhk_type}</li>
                            <li><i className="fa fa-bath" /> {item.number_bathroom}</li>
                            <li><img src={"/assets/img/icons/7.png"} alt={imagealt} /> {item.builtup_area} sq ft</li>
                          </ul> */}
                                                    {/* <ul className="contact-list">
                            <li className="readeal-top"><Link className="btn btn-yellow"
                              //  to={item.url}
                              to={`/property-details/${item.id}`}
                            >View Details</Link></li>
                            <li>
                              <PropertyCallingButton />
                            </li>
                            <li>
                              <PropertyWhatsAppButton />
                            </li>
                          </ul> */}
                                                </div>
                                            </div>
                                            <Modal
                                                title=""
                                                open={open}
                                                onCancel={handleCancel}
                                                footer={null}
                                                maskStyle={{ backgroundColor: 'transparent' }}  //  background black nahi hoga
                                                maskClosable={false}  //  background pe click karne se close bhi nahi hoga
                                            >
                                                <GetInTouch onClose={handleCancel} />
                                            </Modal>
                                        </div>
                                    )
                                })
                            ) : (
                                <div className="col-12 text-center">
                                    <p>There are no properties available in villas at the moment.</p>
                                </div>
                            )}
                        </div>
                        {/* Pagination */}
                        {/* {propertylist.length < propertylist.length && (
                              <div className="property-filter-menu portfolio-filter text-center mb-3">
                                <button
                                  className="btn btn-yellow"
                                  onClick={loadMore}
                                  disabled={loading}
                                >
                                  {loading ? 'Loading...' : 'Load More'}
                                </button>
                              </div>
                            )} */}
                    </>
                )}
            </div>
        </div>
    );

}

export default BlogPropertices;
